import React from 'react';

interface CVE {
	Title?: string;
	Description?: string;
	CVEId: string;
}

interface CveTitleProps {
	cve?: CVE;
}

export default function CveTitle({cve}: CveTitleProps) {
	if (!cve) return (<></>);
	
	if (!!cve.Title) return (<>{cve.Title}</>)
	if (!!cve.Description) {
		if (cve.Description.length < 100) {
			return (<>{cve.Description}</>)
		} else {
			return (<>{cve.Description.substring(0, 100) + '...'}</>)
		}
	}
	if (cve.CVEId !== undefined) return (<>{cve.CVEId}</>)
	return (<></>)
}